import { ChangeEvent } from 'react';
import cn from 'classnames';

import styles from './FilterCheckbox.module.scss';

export interface IFilterCheckboxProps {
  className?: string;
  id?: string;
  name?: string;
  label?: string;
  variant?: 'minimal' | 'contained';
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  error?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  whiteBackground?: boolean;
}

export const FilterCheckbox = ({
  className,
  id,
  label,
  variant = 'contained',
  whiteBackground = undefined,
  disabled,
  onChange,
  ...rest
}: IFilterCheckboxProps) => {
  const filterCheckboxClassNames = cn(styles.FilterCheckbox, className, {
    [styles.FilterCheckboxMinimal]: variant === 'minimal',
    [styles.FilterCheckboxContained]: variant === 'contained',
  });

  return (
    <div className={filterCheckboxClassNames}>
      <input
        className={cn(styles.FilterCheckboxInput, { [styles.WhiteBackground]: whiteBackground })}
        type="checkbox"
        id={id}
        onChange={disabled ? undefined : onChange}
        {...rest}
      />
      <label className={cn(styles.FilterCheckboxLabel, { [styles.WhiteBackground]: whiteBackground })} htmlFor={id}>
        {label}
        <div className={cn(styles.FilterCheckboxToggler, { [styles.WhiteBackground]: whiteBackground })} hidden />
      </label>
    </div>
  );
};
